import {Component, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatList, MatListItem, MatListItemIcon} from '@angular/material/list';
import {MatSelect} from '@angular/material/select';
import {ContactData, ContactService} from '@app/shared/contact.service';
import {FooterComponent} from '../footer/footer.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {TryBlockComponent} from '../try-block/try-block.component';

@Component({
    selector: 'frog-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    imports: [
        ToolbarComponent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatSelect,
        MatOption,
        MatButton,
        MatList,
        MatListItem,
        MatIcon,
        MatListItemIcon,
        TryBlockComponent,
        FooterComponent,
    ],
})
export class ContactComponent implements OnInit {
    public form: UntypedFormGroup;
    public sent: boolean;

    constructor(
        private contactService: ContactService,
        private formBuilder: UntypedFormBuilder,
    ) {
        this.form = formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', [Validators.pattern(/^\d{10}$/)]],
            teamSize: ['', Validators.required],
            industry: ['', Validators.required],
            subject: ['', Validators.required],
            message: '',
        });
        this.sent = false;
    }

    ngOnInit(): void {}

    submit() {
        if (this.form.valid) {
            const contactData = Object.assign(new ContactData(), this.form.value);
            this.contactService.submit(contactData).subscribe(() => {
                this.sent = true;
            });
        }
    }
}
